import React, { useEffect, useState } from 'react';
import { fetchAccessLogs } from '../../api/api';
import styles from './AdminAccessLogs.module.css';
import Spinner from '../Spinner/Spinner';

const AdminAccessLogs = ({ userId, initialDaysBack = 7, hideUserColumn, onClose }) => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [daysBack, setDaysBack] = useState(initialDaysBack);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadLogs = async () => {
            setIsLoading(true);
            try {
                const data = await fetchAccessLogs(daysBack, userId);
                // fallback, gdy backend nie wspiera userId:
                const filtered = userId ? (data || []).filter(l => l.userId === userId) : data;
                setLogs(filtered || []);
                setError(null);
            } catch (e) {
                setError('Błąd podczas pobierania logów dostępu.');
                setLogs([]);
            } finally {
                setIsLoading(false);
            }
        };
        loadLogs();
    }, [daysBack, userId]);

    const formatCode = (code) => (!code ? '-' : code.replace(/(\d{3})(\d{3})/, '$1 $2'));

    return (
        <div className={styles.accessLogs}>
            {/* Nagłówek: tytuł + zamknięcie po prawej */}
            <div className={styles.headerRow}>
                <h4 className={styles.title}>Historia użycia kodu</h4>
                {onClose && (
                    <button
                        className={styles.closeButton}
                        onClick={onClose}
                        aria-label="Zamknij historię"
                        title="Zamknij"
                    >
                        ×
                    </button>
                )}
            </div>

            {/* Selektor dni po lewej */}
            <div className={styles.filterRow}>
                <select value={daysBack} onChange={e => setDaysBack(Number(e.target.value))}>
                    <option value={7}>7 dni</option>
                    <option value={30}>30 dni</option>
                    <option value={90}>90 dni</option>
                </select>
            </div>

            {/* Przewijalny obszar z treścią */}
            <div className={styles.scrollArea}>
                {isLoading ? (
                    <Spinner size="large" />
                ) : error ? (
                    <div className={styles.error}>{error}</div>
                ) : logs.length === 0 ? (
                    <div className={styles.noData}>Brak danych dla wybranego okresu.</div>
                ) : (
                    <table className={styles.table}>
                        <thead>
                        <tr>
                            <th>Data</th>
                            {!hideUserColumn && <th>Użytkownik</th>}
                            <th>Kod</th>
                            <th>Wynik</th>
                        </tr>
                        </thead>
                        <tbody>
                        {logs.map((log) => (
                            <tr key={log.id}>
                                <td>{new Date(log.timestamp).toLocaleString('pl-PL')}</td>
                                {!hideUserColumn && <td>{`${log.firstName} ${log.lastName}`}</td>}
                                <td className={styles.codeCell}>{formatCode(log.codeAttempted)}</td>
                                <td style={{ color: log.success ? 'green' : 'red', fontSize: '18px', textAlign: 'center' }}>
                                    {log.success ? '✓' : '✕'}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default AdminAccessLogs;
